var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightLong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.504 21.2c.661-.66.661-1.73 0-2.383l-9.561-9.569a1.68 1.68 0 00-2.384 0c-.653.661-.66 1.73 0 2.384l6.68 6.679-28.552.006c-.935 0-1.687.753-1.687 1.688 0 .935.752 1.687 1.687 1.687H32.24l-6.68 6.68a1.68 1.68 0 000 2.383c.661.653 1.73.66 2.384 0l9.561-9.555z"
  })));
}
export default SvgArrowRightLong;